import { AxiosResponse } from 'axios';
import apiBack from './api';
import { ProcessEditDTO } from '../types/Process.d';

export class ProcessService {
  static async createProcess(process: ProcessEditDTO): Promise<AxiosResponse> {
    const response = await apiBack.post('/processes', process);
    return response;
  }

  static async findProcess(name: string | undefined, number: string | undefined): Promise<AxiosResponse> {
    const response = await apiBack.get('/processes/find', {
      params: { name, number },
      validateStatus: status => [200, 404].includes(status),
    });
    return response;
  }

  static async editProcess(process: ProcessEditDTO): Promise<AxiosResponse> {
    const response = await apiBack.patch(`/processes/${process.id}`, process);
    return response;
  }

  static async editProcessStatus(processId: number, statusId: number): Promise<AxiosResponse> {
    const processStatusId = {
      processStatusId: statusId,
    };
    const response = await apiBack.patch(`/processes/${processId}/status`, processStatusId, {
      validateStatus: status => [200].includes(status),
    });
    return response;
  }

  static async favouriteProcess(id: number, fav: boolean): Promise<AxiosResponse> {
    const favourite = { favourite: fav };
    const response = await apiBack.patch(`/processes/${id}/favourite`, favourite, {
      validateStatus: status => [200].includes(status),
    });
    return response;
  }
}
